import axios from "axios";

export const pythonVmInstance = axios.create({
	baseURL: process.env.REACT_APP_PYTHON_APP_API_URL,
});
